import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { modalActionType, actionType } from 'utils/constants';

import Attachments from './modals/Attachments';
import BackModal from './modals/BackModal';
import DeleteDocuments from './modals/DeleteDocuments';
import Memo from './modals/Memo';
import NoSubjectDetail from './modals/NoSubjectDetail';
import SaveModal from './modals/SaveModal';
import SearchSubject from './modals/SearchSubject';
import GoAheadModal from './modals/GoAheadModal';
import ChildOf from './modals/ChildOf';
import ContinueWithoutSaving from './modals/ContinueWithoutSaving';
import Log from './modals/Log';
import NewStore from './modals/NewStore';
import SetScanDate from './modals/SetScanDate';
import SplitAndFix from './modals/SplitAndFix';
import RebatchDocument from './modals/RebatchDocument';
import Hotkeys from './modals/HotKeys';
import SelfValidate from './modals/SelfValidate';
import SendToWorkflow from './modals/SendToWorkflow';
import ParkDocument from './modals/ParkDocument';
import RejectDocument from './modals/Reject';
import RejectPrevious from './modals/RejectPrevious';
import Convalida from './modals/Convalida';
import InfoFromWf from './modals/InfoFromWorkflow';
import ConvalidateInfo from './modals/Info';
import Litigation from './modals/Litigation';
import CloseLitigation from './modals/CloseLitigation';
import ValidationCheck from './modals/ValidationCheck';
import SapMessages from './modals/SapMessages';
import SubjectDetails from './modals/SubjectDetails';
import SapUserLogin from './modals/SapUserLogin';
import ReverseRepost from './modals/ReverseRepost';
import ShowSapData from './modals/ShowSapData';
import Mail from './modals/Mail';
import DocumentHistory from './modals/DocumentHistory';
import SupplierIbanList from './modals/SupplierIbanList';
import ValidationConfirmModal from './modals/ValidationConfirmModal';
import PreviousDocuments from './modals/PreviousDocuments';
import ShowResponse from './modals/ShowResponse';

const DetailModals = () => {
  const action = useSelector(selectors.modal.getActionType);

  switch (action) {
    case modalActionType.documents.SEARCH_SUBJECT:
      return <SearchSubject />;
    case modalActionType.documents.ADD_MEMO:
      return <Memo />;
    case modalActionType.documents.DELETE_DOCUMENTS:
      return <DeleteDocuments />;
    case modalActionType.documents.SAVE:
      return <SaveModal />;
    case modalActionType.documents.GO_BACK:
      return <BackModal />;
    case modalActionType.documents.ALLEGA:
      return <Attachments />;
    case modalActionType.documents.NO_SUBJECT_DETAIL:
      return <NoSubjectDetail />;
    case modalActionType.documents.GO_AHEAD:
      return <GoAheadModal />;
    case modalActionType.documents.CHILD_OF:
      return <ChildOf />;
    case modalActionType.documents.CONTINUE_WITHOUT_SAVING:
      return <ContinueWithoutSaving />;
    case modalActionType.documents.LOG:
      return <Log />;
    case modalActionType.documents.NEW_STORE:
      return <NewStore />;
    case modalActionType.documents.LINK_ASSET_ID:
      return <SearchSubject isLinkAsset />;
    case actionType.SET_RECEIPT_DATE:
      return <SetScanDate />;
    case actionType.SPLIT_FIX:
      return <SplitAndFix />;
    case actionType.RETURN_TO_BATCH:
      return <RebatchDocument />;
    case modalActionType.documents.HOT_KEYS:
      return <Hotkeys />;
    case modalActionType.documents.SELF_VALIDATE:
      return <SelfValidate />;
    case modalActionType.documents.SEND_TO_WORKFLOW:
      return <SendToWorkflow />;
    case actionType.PARK:
      return <ParkDocument />;
    case actionType.REJECT:
      return <RejectDocument />;
    case actionType.REJECT_PREVIOUS:
      return <RejectPrevious />;
    case modalActionType.documents.CONFIRM:
      return <Convalida />;
    case actionType.ASK_INFO:
      return <InfoFromWf />;
    case modalActionType.documents.RESPONSE_INFO:
      return <ConvalidateInfo />;
    case modalActionType.documents.LITIGATION:
      return <Litigation />;
    case modalActionType.documents.CLOSE_LITIGATION:
      return <CloseLitigation />;
    case modalActionType.documents.VALIDATION_CHECK:
      return <ValidationCheck />;
    case modalActionType.documents.SUBJECT_DETAILS:
      return <SubjectDetails />;
    case modalActionType.documents.REVERSE_REPOST:
      return <ReverseRepost />;
    case modalActionType.documents.SHOW_SAP_DATA:
      return <ShowSapData />;
    case modalActionType.documents.SAP_MESSAGES:
      return <SapMessages />;
    case modalActionType.documents.SAP_USER_LOGIN:
      return <SapUserLogin />;
    case modalActionType.documents.SEND_MAIL:
      return <Mail />;
    case modalActionType.documents.DOCUMENT_HISTORY:
      return <DocumentHistory />;
    case modalActionType.documents.SUPPLIER_IBAN_LIST:
      return <SupplierIbanList />;
    case modalActionType.documents.VALIDATION_CONFIRM_MODAL:
      return <ValidationConfirmModal />;
    case actionType.VIEW_PREVIOUS_DOCUMENTS:
      return <PreviousDocuments />;
    case modalActionType.documents.SHOW_RESPONSE:
      return <ShowResponse />;
    default:
      return <div>{`${action} not supported`}</div>;
  }
};

export default DetailModals;
